export default {
    data() {
        return {
            refreshing: false,
            registration: null,
            updateExists: false,
        }
    },
    watch: {
 
        updateExists (val) {
 
            if (!val) return
    
            this.$alert(
                'Para asegurar el correcto funcionamiento de la aplicación es recomendable actualizar', 
                'Se ha encontrado una actualización', 
                {
                    confirmButtonText: 'Actualizar',
                    center: true,
                    callback: () => this.refreshApp()
                });
 
        }
 
    },
    created() {
        this.init()
    },
    methods: {

        async init() {

            document.addEventListener('swUpdated', this.updateAvailable, { once: true })
 
            if (!navigator.serviceWorker) return
    
            // navigator.serviceWorker.addEventListener('controllerchange', async () => {

            //     console.log('controllerchange')
    
            //     if (this.refreshing) return
    
            //     this.refreshing = true
                
            //     await this.clearIndexedDB()

            //     window.location.reload()
    
            // })
        },
 
        updateAvailable(event) {
            this.registration = event.detail
            this.updateExists = true
        },
 
        async refreshApp() {
            console.log('manual refresh app')
            
            await this.clearIndexedDB()

            window.location.reload()

            /*this.updateExists = false
            if (!this.registration || !this.registration.waiting) return

            this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
            */
 
        },

       async clearIndexedDB() {
            let databases = await indexedDB.databases()

            console.log('databases: ', databases)
            databases.forEach(db => {
                indexedDB.deleteDatabase(db)
            })
            
            console.log('clearIndexedDB end')
        }
    }
}